<div class="container">
      <section class="inner-container">
        <main>
          <div class="contact-form" style="background-image: url(images/login-bg.jpg); background-size: cover; height: 80vh; padding-top: 9vh">
            <div class="row">
              <div class="col-md-4">
              </div>
              <!--; margin-left: 3em; margin-right: 3em; max-width: 500px-->
              <div class="col-md-4" style="border-radius: 25px; background: white; opacity: 0.9; padding: 3em">
                <form name="login-form" id="login-form" data-k2-validation="true" class="general-form" #f="ngForm" novalidate>
                  <h5 class="title-form">Welcome Back!</h5>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                        <input type="text" name="email" id="email" placeholder="" [(ngModel)]="user.email" class="custom-input" required data-rules="required|email" data-error-mes="This field is required|Email is invalid" trim>
                        <label>E-mail</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                        <input type="password" name="password" id="password" [(ngModel)]="user.password" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required">
                        <label>Password</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group mid">
                      <button type="submit" class="btn btn-primary btn-block" (click)="login()">Log In</button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mid">
                        <a routerLink="/forgotPassword"><u>Forgot Password</u></a>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="row">
                  <div class="col-md-12">
                    <h1 class="mid">Don't have an account? <a routerLink="/register"><u>Sign up</u></a>.</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </section>
    </div>

